export default "__VITE_ASSET__CXLtrX1Y__"